import store from '../../store'
import Vue from 'vue'

export default {
  componentUpdated: handleImageLoad,
  inserted: handleImageLoad
}

function handleImageLoad (el, binding) {
  function loadImage () {
    const hoverImg = Array.from(el.children).find(child => child.className === 'listhoverimg')
    const imageElement = Array.from(el.children).find(child => child.nodeName === 'IMG')

    if (!imageElement) return

    const renderWidth = el.getBoundingClientRect().width
    const compressedImg = renderWidth > 0 ? imageElement.dataset.url : ''
    let extractedGumletConfig = null

    if (imageElement.dataset.src !== compressedImg) {
      imageElement.dataset.src = compressedImg

      imageElement.addEventListener('load', () => {
        handleImageLoadSuccess(binding, el, imageElement, hoverImg, compressedImg, extractedGumletConfig)
      })

      imageElement.addEventListener('error', () => console.log('Error loading image'))
    }
  }

  function handleImageLoadSuccess (binding, el, imageElement, hoverImg, compressedImg, extractedGumletConfig) {
    if (binding && binding.value) {
      const localBindingValue = { ...binding.value }
      const searchTerm = localBindingValue.searchTerm || ''
      const CallerComp = localBindingValue.item_list_name || ''
      const isSelectedCountryIndia = localBindingValue.isSelectedCountryIndia
      const enableVincenzeSearch = localBindingValue.enableVisenzeSearch
      if (localBindingValue.searchTerm) delete localBindingValue.searchTerm
      const widgetClickPosition = Vue.ls.get('widget_click_position') || {}
      const widgetCurrentRoute = localBindingValue.widget_current_route || ''

      store.commit('EC_PLP_PROD_VIEW_PUSH', {
        ...localBindingValue,
        item_list_name: localBindingValue.item_list_name || 'NA'
      })
      store.commit('MOENGAGE_EVENT', {eventName: 'WIDGET-VIEW',
        payload: {
          ...localBindingValue,
          widget_name: CallerComp && CallerComp ? CallerComp.toLowerCase() : '',
          widget_click_position: widgetClickPosition && widgetClickPosition.route,
          widget_current_route: widgetCurrentRoute
        }}
      )
      store.commit('MOENGAGE_PLP_PROD_VIEW_PUSH', localBindingValue)
      handleImpressionDelayed(searchTerm, CallerComp, isSelectedCountryIndia, enableVincenzeSearch, 200)
    }

    setTimeout(() => {
      el.classList.add('loaded')
      const checkDrop = Vue.ls.get('pdp_checkDrop')
      if (checkDrop) {
        el.classList.add('customFade-active-drop')
      } else {
        imageElement.classList.add('customFade-active')
      }
    }, 1)

    if (!extractedGumletConfig) {
      extractedGumletConfig = extractGumletConfig(imageElement.src)
    }

    if (hoverImg && window.innerWidth >= 768) {
      const compressedHoverImg = `${hoverImg.dataset.url}${extractedGumletConfig ? `?${extractedGumletConfig}` : ''}`
      if (hoverImg.style.backgroundImage !== `url(${compressedHoverImg})`) {
        hoverImg.style.backgroundImage = `url(${compressedHoverImg})`
      }
    }
  }

  function extractGumletConfig (src) {
    const extractor = src && src.includes('?') && src.split('?')
    return extractor && extractor[1] ? extractor[1] : ''
  }

  function handleImpressionDelayed (searchTerm, CallerComp, isSelectedCountryIndia, enableVincenzeSearch, delayTime) {
    setTimeout(() => {
      handleImpression(searchTerm, CallerComp, isSelectedCountryIndia, enableVincenzeSearch)
    }, delayTime)
  }

  function handleImpression (searchTerm, CallerComp, isSelectedCountryIndia, enableVincenzeSearch) {
    if (store.getters.tatvicProductImpression.data.length >= 1) {
      store.dispatch('ECOMMERCE_EVENT', {
        eventName: 'view_item_list',
        payload: {
          items: [...store.getters.tatvicProductImpression.data]
        }
      })
      const cleanedData = store.getters.tatvicProductImpression.data.map(
        ({ image_url, image_arr, image_name, isSelectedCountryIndia, enableVisenzeSearch, widget_current_route, ...rest }) => rest
      )
      store.commit('GTM_EVENT', {
        eventName: 'view_item_list',
        payload: {
          items: cleanedData
        }
      })
      if ((searchTerm || CallerComp === 'Recommended Products') && enableVincenzeSearch && isSelectedCountryIndia) {
        const dataArray = store.getters.tatvicProductImpression.data
        if (Array.isArray(dataArray) && dataArray.length > 0) {
          dataArray.forEach((item, index) => {
            store.commit('VINSENZE_EVENT', {
              eventName: 'product_view',
              payload: {
                queryId: localStorage.getItem('visenze_queryId') || 'none',
                pid: Number(item.item_id), // Assuming item_id is the key for the product ID
                pos: Number(item.index) + 1, // Position starts at 1
                imUrl: item.image_url
              }
            })
          })
        } else {
          console.log(' No valid data found in tatvicProductImpression.')
        }
      }
      store.commit('EC_PLP_PROD_VIEW_RESET')
    }
  }

  function handleIntersect (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadImage()
        observer.unobserve(el)
      }
    })
  }

  function createObserver () {
    const observer = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: 0
    })

    observer.observe(el)
  }

  if ('IntersectionObserver' in window) {
    createObserver()
  } else {
    loadImage()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/imgLazyLoadObserver.js